import React from 'react'
import IntlMessages from '../../helpers/IntlMessages'
import styles from './index.module.css'

export default function Spinner({ hideText = false }) {
    return (
        <div className={styles.container}>
            <div className={styles.spinner}></div>
            {!hideText && <p><IntlMessages id="general.loading" /></p>}
        </div>
    )
}
